<template>
  <generic-modal
    size="small"
    :title="$t('360 feedback configuration')"
    icon="cogs"
    image="/images/icons/staff_rating.png"
    v-bind:scrolling="true"
    v-on:destroy="destroy"
    v-bind:on_finished="finished"
  >
    <div class="description">
      <div class="ui form">
        <div class="ui two item top attached tabular menu" ref="tabs">
          <div class="active item" data-tab="general">
            <i class="info icon"></i> {{ $t("general") }}
          </div>
          <div class="item" data-tab="integration">
            <i class="cubes icon"></i> {{ $t("integration") }}
          </div>
        </div>
        <div class="ui bottom attached active tab segment" data-tab="general">
          <!-- <div class="ui dividing header">
          {{ $t("visalink connection info") }}
        </div> -->
          <div class="field">
            <label for="">{{ $t("evaluation expire time") }}</label>
            <div class="fields">
              <div class="eight wide field">
                <!-- <label for>{{
                            $t("reusable link time threshold")
                          }}</label> -->
                <input
                  type="text"
                  name="time_threshold"
                  v-model="expire_time"
                />
              </div>
              <div class="eight wide field">
                <!-- <label for>{{ $t("reusable link time unit") }}</label> -->
                <select
                  ref="expire_time_dropdown"
                  class="ui selection dropdown"
                  name="time_threshold_unit"
                  v-model="expire_time_unit"
                >
                  <option value="">{{ $t("select one") }}</option>
                  <option value="day">{{ $t("day") }}</option>
                  <option value="week">{{ $t("week") }}</option>
                  <option value="month">{{ $t("month") }}</option>
                </select>
              </div>
            </div>
          </div>
          <div class="fields">
            <div class="eight wide field">
              <label for="">{{ $t("step buttons color") }}</label>
              <input
                type="text"
                name="step_button_color"
                v-model="step_button_color"
                :style="'background-color: #' + step_button_color"
              />
            </div>
            <div class="eight wide field">
              <label for="">{{ $t("step marks color") }}</label>
              <input
                type="text"
                name="step_mark_color"
                v-model="step_mark_color"
                :style="'background-color: #' + step_mark_color"
              />
            </div>
          </div>
          <div class="fields">
            <div class="ten wide field">
              <label for="">{{ $t("logo") }}</label>
              <file-uploader
                name="file"
                url="/survey/template/do-upload-logo"
                @error="error_uploading"
                @uploaded="end_uploading"
              />
            </div>
            <img
              v-if="logo && logo.relative_path"
              class="ui small image"
              :src="api_host + '/' + logo.relative_path"
            />
          </div>
        </div>
        <div class="ui bottom attached tab segment" data-tab="integration">
          <h4 class="ui dividing header">{{ $t("outbox integration") }}</h4>
          <div class="field">
            <div class="ui toggle checkbox">
              <input
                type="checkbox"
                name="send_notification"
                v-model="outbox_send_notification"
              />
              <label>{{
                $t("send notification e-mail to evaluating user")
              }}</label>
            </div>
          </div>
          <div class="field">
            <label>{{ $t("outbox template") }}</label>
            <div class="ui selection dropdown" ref="template_dropdown">
              <div class="text"></div>
              <i class="dropdown icon"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
  </generic-modal>
</template>

<script>
// import { local_api, stringify } from "@/utils";
import GenericModal from "@/components/GenericModal";
import { local_api, error_toast, api_host } from "@/utils";
import FileUploader from "@/components/FileUploader.vue";
// import { v4 } from "uuid";

export default {
  name: "StaffRatingTemplateConfigurationModal",
  components: {
    "generic-modal": GenericModal,
    FileUploader,
  },
  computed: {
    api_host() {
      return api_host;
    },
  },
  data() {
    return {
      expire_time: "",
      expire_time_unit: "",
      step_button_color: "",
      step_mark_color: "",
      logo: {},
      outbox_template_id: "",
      outbox_send_notification: false,
    };
  },
  methods: {
    destroy() {
      this.$emit("destroy");
      this.$destroy();
    },
    finished() {
      let vm = this;
      return new Promise(function(resolve, reject) {
        local_api(
          vm,
          "post",
          "/staff_rating/organization/do-save-configuration",
          {
            s: {
              expire_time: vm.expire_time,
              expire_time_unit: vm.expire_time_unit,
              step_button_color: vm.step_button_color,
              step_mark_color: vm.step_mark_color,
              logo: vm.logo,
              outbox_send_notification: vm.outbox_send_notification,
              outbox_template_id: vm.outbox_template_id,
            },
          },
        )
          .then(() => {
            resolve();
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    error_uploading(err) {
      console.error(err);
    },
    end_uploading(file) {
      let vm = this;
      vm.logo = file;
    },
  },
  mounted() {
    let vm = this;

    /** Outbox integration */
    local_api(vm, "post", "/outbox/template/do-get-list")
      .then((templates) => {
        if (templates) {
          let vls = templates.map((t) => {
            return { name: t.name, value: t.template_id };
          });

          window
            .jQuery(vm.$refs.template_dropdown)
            .dropdown("setup menu", { values: vls })
            .dropdown({
              onChange(value) {
                vm.outbox_template_id = value;
              },
            });
        }

        /** Load module configuration */
        local_api(vm, "post", "/staff_rating/organization/do-get-configuration")
          .then((conf) => {
            if (conf) {
              if (conf.expire_time) vm.expire_time = conf.expire_time;
              if (conf.expire_time_unit) {
                window
                  .jQuery(vm.$refs.expire_time_dropdown)
                  .dropdown("set selected", conf.expire_time_unit);
                vm.expire_time_unit = conf.expire_time_unit;
              }
              if (conf.step_button_color)
                vm.step_button_color = conf.step_button_color;
              if (conf.step_mark_color)
                vm.step_mark_color = conf.step_mark_color;
              if (conf.logo) vm.logo = conf.logo;
              if (conf.outbox_send_notification)
                vm.outbox_send_notification = conf.outbox_send_notification;
              if (conf.outbox_template_id) {
                window
                  .jQuery(vm.$refs.template_dropdown)
                  .dropdown("set selected", conf.outbox_template_id);
                // vm.outbox_template_id = conf.outbox_template_id;
              }
            }

            window
              .jQuery(vm.$refs.tabs)
              .find(".item")
              .tab();
            // console.log(conf);
          })
          .catch((err) => {
            error_toast(err);
          });
      })
      .catch((err) => {
        error_toast(err);
      });

    window.jQuery(vm.$refs.expire_time_dropdown).dropdown();
  },
  watch: {},
  updated: function() {},
};
</script>
